import { render, staticRenderFns } from "./select-option.vue?vue&type=template&id=4d54a5c8&"
import script from "./select-option.vue?vue&type=script&lang=js&"
export * from "./select-option.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports